<div style="height: 100%; width: 100%;">
<optima-explorer
#measureExplorer
[isLoading]="isLoading()"
[explorerAttributes]="explorerAttributes"
[contentTotalCount]="getContentTotalCount()"
[contentItemCountPerPage]="contentItemCountPerPage"
[dataRefreshedToken]="dataRefreshedToken"
(paginationRequest)="onPaginationRequest($event)"
(subHeaderOnClickAddButtonOptionEmitter)="onAddButtonOptionClick($event)"
(subHeaderOnForwardButtonClickedEmitter)="itemClicked($event,false)"
(explorerNavOnNavItemClickedEmitter)="navItemClicked($event)"
(explorerContentOncontextMenuClickEmitter)="processContentContextMenuClicked($event)"
(explorerNavonExplorerNavOnItemRightClickEmitter)="processContentContextMenuClicked($event)"
></optima-explorer>
</div>
<!-- <app-off-canvas-collective></app-off-canvas-collective> -->